import React from "react"
import {
  FacebookShareButton,
  FacebookIcon,
  LinkedinShareButton,
  LinkedinIcon,
  TwitterShareButton,
  TwitterIcon,
  WhatsappShareButton,
  WhatsappIcon,
  RedditShareButton,
  RedditIcon,
} from "react-share"
import "./component.css"

export const ShareButtons = ({ twitterHandle, url, title, tags, size }) => (
  <div>
    <FacebookShareButton url={url} style={{paddingRight: 5}} >
      <FacebookIcon round={true} size={size || 25} />
    </FacebookShareButton>

    <TwitterShareButton
      url={url}
      title={title}
      via={twitterHandle}
      hashtags={tags}
      style={{paddingRight: 5}}
    >
      <TwitterIcon round={true} size={size || 25}/>
    </TwitterShareButton>

    <LinkedinShareButton url={url} style={{paddingRight: 5}}>
      <LinkedinIcon round={true} size={size || 25}/>
    </LinkedinShareButton>

    <RedditShareButton url={url} title={title} style={{paddingRight: 5}}>
      <RedditIcon round={true} size={size || 25}/>
    </RedditShareButton>

    <WhatsappShareButton url={url} title={title} style={{paddingRight: 5}}>
      <WhatsappIcon round={true} size={size || 25}/>
    </WhatsappShareButton>
  </div>
)

export default ShareButtons
